import { createStyles } from '@material-ui/core';
import { fade } from '@material-ui/core/styles';
export default (function (theme) {
  return createStyles({
    formContainer: {
      position: 'relative'
    },
    hiddenInputWrap: {
      padding: '0px !important'
    },
    buttonLeftIcon: {
      marginRight: theme.spacing(1)
    },
    groupBox: {
      borderBottom: '1px solid rgba(224, 224, 224, 1)'
    },
    groupHeader: {
      flexDirection: 'row',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    },
    groupHeaderTitleSlim: {
      fontSize: 13
    },
    groupForm: {
      borderTop: '1px solid rgba(224, 224, 224, 1)',
      padding: theme.spacing(1),
      marginTop: theme.spacing(1) // background: 'rgba(0,0,0,0.03)'

    },
    slimGroupForm: {
      padding: theme.spacing(0.5),
      marginTop: theme.spacing(0.5)
    },
    groupButton: {
      flex: '0 0 auto',
      display: 'inline-flex'
    },
    modalButtons: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      '& button': {
        margin: theme.spacing(0, 1),
        '&:first-child': {
          marginLeft: 0
        },
        '&:last-child': {
          marginRight: 0
        }
      }
    },
    fieldContainer: {
      position: 'relative',
      display: 'block'
    },
    dynamicField: {
      '& + $dynamicField': {
        marginTop: theme.spacing(1)
      }
    },
    fieldActions: {
      position: 'absolute',
      right: 0,
      top: 3
    },
    slimFieldActions: {
      top: 0
    },
    buttonSlim: {
      padding: theme.spacing(0.25, 0.5),
      fontSize: 11
    },
    dynamicGroupButtons: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      marginBottom: theme.spacing(1)
    },
    dynamicGroupErrors: {
      display: 'block',
      width: '100%',
      color: '#fff',
      backgroundColor: fade(theme.palette.error.light, 0.6),
      padding: theme.spacing(0.5, 1),
      marginBottom: theme.spacing(2),
      borderRadius: theme.spacing(0.5)
    },
    dynamicGroupTableRowSlim: {
      height: 20
    },
    dynamicGroupTableCellSlim: {
      padding: '4px 8px 2.4px',
      fontSize: 12,
      lineHeight: 1.1
    },
    gridOffsetLeft1: {
      marginLeft: "".concat(1 / 12 * 100, "%")
    },
    gridOffsetLeft2: {
      marginLeft: "".concat(2 / 12 * 100, "%")
    },
    gridOffsetLeft3: {
      marginLeft: "".concat(3 / 12 * 100, "%")
    },
    gridOffsetLeft4: {
      marginLeft: "".concat(4 / 12 * 100, "%")
    },
    gridOffsetLeft5: {
      marginLeft: "".concat(5 / 12 * 100, "%")
    },
    gridOffsetLeft6: {
      marginLeft: "".concat(6 / 12 * 100, "%")
    },
    gridOffsetLeft7: {
      marginLeft: "".concat(7 / 12 * 100, "%")
    },
    gridOffsetLeft8: {
      marginLeft: "".concat(8 / 12 * 100, "%")
    },
    gridOffsetLeft9: {
      marginLeft: "".concat(9 / 12 * 100, "%")
    },
    gridOffsetLeft10: {
      marginLeft: "".concat(10 / 12 * 100, "%")
    },
    gridOffsetLeft11: {
      marginLeft: "".concat(11 / 12 * 100, "%")
    },
    gridOffsetLeft12: {
      marginLeft: "".concat(12 / 12 * 100, "%")
    },
    gridOffsetRight1: {
      marginRight: "".concat(1 / 12 * 100, "%")
    },
    gridOffsetRight2: {
      marginRight: "".concat(2 / 12 * 100, "%")
    },
    gridOffsetRight3: {
      marginRight: "".concat(3 / 12 * 100, "%")
    },
    gridOffsetRight4: {
      marginRight: "".concat(4 / 12 * 100, "%")
    },
    gridOffsetRight5: {
      marginRight: "".concat(5 / 12 * 100, "%")
    },
    gridOffsetRight6: {
      marginRight: "".concat(6 / 12 * 100, "%")
    },
    gridOffsetRight7: {
      marginRight: "".concat(7 / 12 * 100, "%")
    },
    gridOffsetRight8: {
      marginRight: "".concat(8 / 12 * 100, "%")
    },
    gridOffsetRight9: {
      marginRight: "".concat(9 / 12 * 100, "%")
    },
    gridOffsetRight10: {
      marginRight: "".concat(10 / 12 * 100, "%")
    },
    gridOffsetRight11: {
      marginRight: "".concat(11 / 12 * 100, "%")
    },
    gridOffsetRight12: {
      marginRight: "".concat(12 / 12 * 100, "%")
    }
  });
});